
<button [disabled]="isDisabled()" [class]="{'side-menu-tab__button--selected': isSelected()}" mat-button (click)="onTabClick()"><ng-content select="appSideMenuTabLabel"/>
@if(labelTemplate()){
		<!--eslint-disable-next-line @angular-template/prefer-self-closing-tags-->
		<ng-container [ngTemplateOutlet]="labelTemplate()!.template" ></ng-container> 
	}
</button>

<ng-template #tabContent>
	<ng-content/>
</ng-template>